module.exports = __webpack_public_path__ + "fonts/Golos-Text_Medium.5f14636.woff";